<template>
  <div>
    <v-row>
      <v-col cols="3">
        <v-text-field
          label="Фамилия"
          outlined
          v-model="v.lastName.$model"
          :errorMessages="getValidationErrorText(v.lastName)"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          label="Имя"
          outlined
          v-model="v.firstName.$model"
          :errorMessages="getValidationErrorText(v.firstName)"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          label="Отчество (при наличии)"
          outlined
          v-model="v.patronymic.$model"
          :errorMessages="getValidationErrorText(v.patronymic)"
        />
      </v-col>
      <v-col cols="3">
        <DateFieldCustom
          label="Дата рождения"
          :value="v.birthDate.$model"
          @change="v.birthDate.$model = $event"
          :errorMessage="v.birthDate"
          :max="new Date().toISOString()"
        />
      </v-col>

      <v-col cols="3">
        <v-text-field
          v-model="v.snils.$model"
          :errorMessages="getValidationErrorText(v.snils)"
          label="СНИЛС"
          v-mask="['###-###-### ##']"
          outlined
          :disabled="v.mrpDisabled.$model.includes('snils')"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="v.inn.$model"
          :errorMessages="getValidationErrorText(v.inn)"
          label="ИНН"
          v-mask="['############']"
          outlined
          :disabled="v.mrpDisabled.$model.includes('inn')"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="v.email.$model"
          :errorMessages="getValidationErrorText(v.email)"
          label="Адрес электронной почты"
          outlined
        />
      </v-col>
    </v-row>

    <MrpaTrustee
      :v="v.trustee"
      label="Сведения о представителе физического лица"
    />
  </div>
</template>

<script>
import { and, maxLength, minLength, required } from 'vuelidate/lib/validators';
import {
  PERSON_NAME,
  EMAIL,
  getValidationErrorText,
  INN_ROD,
  MAX_LENGTH,
  MAX_LENGTH_EMAIL,
  MinLength,
  SNILS_ROD,
  DATE_FORMAT,
  DATE_FUTURE,
  DATE_PAST,
} from '@/utils/validate';
import { Mask } from '@/constants';
import DateFieldCustom from '@/components/base/DateFieldCustom';
import MrpaTrustee, {
  mrpaTrusteeModel,
  getMrpaTrusteeValidation,
} from '@/components/services/elements/MrpaTrustee';
import cloneDeep from 'clone-deep';

export const mrpaPersonModel = {
  lastName: '',
  firstName: '',
  patronymic: '',
  birthDate: '',
  snils: '',
  inn: '',
  email: '',
  trustee: cloneDeep(mrpaTrusteeModel),
  mrpDisabled: [],
};

export const getMrpaPersonValidation = (person) => ({
  lastName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  firstName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  patronymic: {
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  birthDate: {
    required,
    DATE: and(DATE_FORMAT, DATE_FUTURE, DATE_PAST),
  },
  snils: {
    required,
    minLength: minLength(MinLength.SNILS),
    SNILS: SNILS_ROD,
  },
  inn: {
    required,
    minLength: minLength(12),
    INN: INN_ROD,
  },
  email: {
    required,
    EMAIL,
    maxLength: maxLength(MAX_LENGTH_EMAIL),
  },
  trustee: getMrpaTrusteeValidation(person.trustee),
  mrpDisabled: {},
});

export default {
  name: 'MrpaPerson',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    DateFieldCustom,
    MrpaTrustee,
  },
  data: () => ({
    Mask,
    getValidationErrorText,
  }),
};
</script>
